import React, { useEffect, useState } from "react";
import CreateFreeTrialParent from "./CreateFreeTrialParent";
import ManageCampaignsModal from "./ManageCampaignsModal";
import SendEmailToLeadModal from "./SendEmailToLeadModal";
import ScheduleMeetingModal from "./ScheduleMeetingModal";
import Tooltip from "rsuite/Tooltip";
import Whisper from "rsuite/Whisper";
import { getFormattedDate } from "../../../../actions/common";
import { NavLink } from "react-router-dom";
import FreeTrialConfirmation from "./FreeTrialConfirmation";
import LoginToAccount from "./LoginToAccount";
import toast from "react-hot-toast";

const CrmLeadsHeader = ({
  customerDetails,
  productsList,
  currentUser,
  refreshCustomerDetails,
  ismuvi5
}) => {
  const [showLoginToAccountModal, setShowLoginToAccountModal] = useState(false);
  const [loginData, setLoginData] = useState({});
  const [createTrialModalOpen, setCreateTrialModalOpen] = useState(false);
  const [apiUrl, setApiUrl] = useState("");
  const [appToken, setAppToken] = useState("");
  const [emailModalOpen, setEmailModalOpen] = useState(false);
  const [showSendEmailToLeadModal, setShowSendEmailToLeadModal] =
    useState(false);
  const [showManageCampaignsModal, setShowManageCampaignsModal] =
    useState(false);
  const [showScheduleMeetingModal, setShowScheduleMeetingModal] =
    useState(false);

  const [formData, setFormData] = useState({
    customerName: "",
    companyName: "",
    phoneNumber: "",
    emailId: "",
    password: "",
    products: [],
  });

  useEffect(() => {
    getLoginData();
  }, [customerDetails, ismuvi5]);

  const getLoginData = () => {
    if (!customerDetails) return;
    if (!customerDetails.product || customerDetails.product.length === 0)
      return;

    let data = {};
    const productKey =
      (customerDetails &&
        customerDetails.product &&
        customerDetails.product[0]) ||
      "";

    if (ismuvi5) {
      data = {
        title: `Login To Account`,
        confirmText: `Are you sure you want to log in to the account?`,
        product_key: productKey,
        enterprise_api_gateway_url: customerDetails.enterprise_api_gateway_url ? customerDetails.enterprise_api_gateway_url  : "https://cms.muvi.com",
        encrypted_password: customerDetails.encrypted_password || "",
        email: customerDetails.email || "",
        store_id: "",
        isMuvi5: ismuvi5,
        customer_id: customerDetails.customer_id || "",
        mautic_id: customerDetails.mautic_id || "",
        studio_id: customerDetails.customer_id || ""
      };
    } else {
      data = {
        title: `Login To Account`,
        confirmText: `Are you sure you want to log in to the account?`,
        product_key: productKey,
        user_uuid: customerDetails.customer_user_uuid || "",
        customer_id: customerDetails.customer_id || "",
        mautic_id: customerDetails.mautic_id || "",
      };
    }

    setLoginData(data);
  };

  const handleShowLoginToAccountModal = () => {
    setShowLoginToAccountModal(true);
  };

  const handleCloseLoginToAccountModal = () => {
    setShowLoginToAccountModal(false);
  };

  const getRecentLogo = () => {
    let companyName = customerDetails.company_name;

    if (!companyName) {
      const email = (customerDetails ? customerDetails.email : "") || "";
      companyName = email.substring(0, email.indexOf("@"));
      if (!companyName) {
        companyName = "Unknown Contact";
      }
    }

    return (
      <img
        src={`https://ui-avatars.com/api/?name=${
          companyName || "Unknown Contact"
        }`}
        alt="Logo"
        class="store-logo"
      />
    );
    // if (customerDetails && customerDetails.logo != "" && customerDetails.logo) {
    //   return <img src={customerDetails.logo} alt="Logo" class="store-logo" />;
    // } else {
    // }
  };

  const mailTriggerPopup = async (appToken) => {
    try {
      setCreateTrialModalOpen(false);
      setAppToken(appToken);
      const emailPayload = {
        username: formData.customerName,
        email: formData.emailId,
        login_url: process.env.REACT_APP_LOGIN_URL,
        password: formData.password,
      };

      const response = await fetch(`${apiUrl}/CrmRest/FreeTrialSuccess`, {
        method: "POST",
        body: JSON.stringify(emailPayload),
      });

      const successResult = await response.json();

      if (successResult && successResult.code === 200) {
        if (refreshCustomerDetails) {
          refreshCustomerDetails();
        }
        setEmailModalOpen(true);
      } else {
        console.error("Error in mail trigger popup:", successResult);
      }
    } catch (error) {
      console.error("Error triggering mail popup:", error);
    }
  };

  const getAvailableProductsForFreeTrial = () => {
    if (!customerDetails || !customerDetails.product) {
      return productsList.map((product, index) => {
        return {
          id: index + 1,
          label: product.value,
          value: product.product_key,
        };
      });
    }

    const usedProductKeys = customerDetails.product;

    const products = productsList.filter(
      (product) => !usedProductKeys.includes(product.product_key)
    );

    return products.map((product, index) => {
      return {
        id: index + 1,
        label: product.value,
        value: product.product_key,
      };
    });
  };

  return (
    <div class="crm-leads-header">
      <div class="navigation-buttons">
        <div
          className={`nav-button ${
            customerDetails && customerDetails.previous_contact_id
              ? ""
              : "disabled"
          }`}
        >
          {customerDetails && customerDetails.previous_contact_id ? (
            <NavLink
              to={`/contact/${customerDetails.previous_contact_id}`}
              className="informDone"
            >
              <svg
                width={"16"}
                height={"16"}
                viewBox="0 0 1024 1024"
                className="icon"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                fill="#000000"
              >
                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path d="M768 903.232l-50.432 56.768L256 512l461.568-448 50.432 56.768L364.928 512z"></path>
                </g>
              </svg>
            </NavLink>
          ) : (
            <span className="informDone">
              <svg
                width={"16"}
                height={"16"}
                viewBox="0 0 1024 1024"
                className="icon"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                fill="#000000"
              >
                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path d="M768 903.232l-50.432 56.768L256 512l461.568-448 50.432 56.768L364.928 512z"></path>
                </g>
              </svg>
            </span>
          )}
        </div>
        <div
          className={`nav-button ${
            customerDetails && customerDetails.next_contact_id ? "" : "disabled"
          }`}
        >
          {customerDetails && customerDetails.next_contact_id ? (
            <NavLink
              to={`/contact/${customerDetails.next_contact_id}`}
              className="informDone"
            >
              <svg
                width={"16"}
                height={"16"}
                viewBox="0 0 1024 1024"
                className="icon"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                fill="#000000"
              >
                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path d="M256 120.768L306.432 64 768 512l-461.568 448L256 903.232 659.072 512z"></path>
                </g>
              </svg>
            </NavLink>
          ) : (
            <span className="informDone">
              <svg
                width={"16"}
                height={"16"}
                viewBox="0 0 1024 1024"
                className="icon"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                fill="#000000"
              >
                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path d="M256 120.768L306.432 64 768 512l-461.568 448L256 903.232 659.072 512z"></path>
                </g>
              </svg>
            </span>
          )}
        </div>
      </div>
      <div class="top-area p-8">
        <div class="profile-area border-0">
          {/* <NavLink
            to={{
              pathname: "/contacts/list",
            }}
            className="back-btn"
          >
            <svg
              stroke="currentColor"
              fill="currentColor"
              stroke-width="0"
              viewBox="0 0 24 24"
              height="1em"
              width="1em"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M21 11H6.414l5.293-5.293-1.414-1.414L2.586 12l7.707 7.707 1.414-1.414L6.414 13H21z"></path>
            </svg>
          </NavLink> */}
          <div class="profile-left" style={{ paddingTop: "8px" }}>
            <div class="img-box">{getRecentLogo()}</div>
            <div class="text-area">
              <div class="d-flex align-items-center">
                <div class="name">{customerDetails.name || "-N/A-"}</div>

                {/* TODO: Add rating value here */}
                {/* Rating */}
                {/* <div
                  class="middle d-flex align-items-center starbadge"
                  style={{ padding: "4px" }}
                >
                  <div class="fulltext-content">
                    <div class="text">{customerDetails.lead_score || "0"}</div>
                  </div>
                </div> */}
              </div>

              {/* <div class="email">
                {customerDetails.domain && customerDetails.domain !== "NA" && (
                  <a
                    href={`${
                      customerDetails.domain.startsWith("http://") ||
                      customerDetails.domain.startsWith("https://")
                        ? customerDetails.domain
                        : `https://${customerDetails.domain}`
                    }`}
                    target="_blank"
                    className="link_new_domain"
                  >
                    {customerDetails.domain ? customerDetails.domain : "NA"}
                  </a>
                )}
              </div> */}
              <div class="d-flex flex-profile-1" style={{ gap: "12px" , flexWrap:"wrap"}}>
                <div class="ps-0 pe-0">
                  <Whisper
                    placement="bottom"
                    trigger="hover"
                    speaker={<Tooltip>Email</Tooltip>}
                  >
                    <button
                      class="single-box flex-direction-column align-items-center pt-0 pb-0 btn-ghost"
                      onClick={() => setShowSendEmailToLeadModal(true)}
                    >
                      <div class="icon-box me-0">
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1.94762 2.5614H14.2147V4.35659L7.93169 8.91103L1.6485 4.15712L1.94762 2.5614Z"
                            fill="#006EFA"
                          ></path>
                          <path
                            d="M2.66665 2.66666H13.3333C14.0666 2.66666 14.6666 3.26666 14.6666 3.99999V12C14.6666 12.7333 14.0666 13.3333 13.3333 13.3333H2.66665C1.93331 13.3333 1.33331 12.7333 1.33331 12V3.99999C1.33331 3.26666 1.93331 2.66666 2.66665 2.66666Z"
                            stroke="#006EFA"
                            stroke-width="1.33"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                          <path
                            d="M14.6666 4L7.99998 8.66667L1.33331 4"
                            stroke="#006EFA"
                            stroke-width="1.33"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                        </svg>
                      </div>
                    </button>
                  </Whisper>
                </div>
                <div class="ps-0 pe-0">
                  <Whisper
                    placement="bottom"
                    trigger="hover"
                    speaker={<Tooltip>Create Deal</Tooltip>}
                  >
                    <button
                      class="single-box flex-direction-column align-items-center pt-0 pb-0 btn-ghost"
                      onClick={() => {
                        window.open(
                          `/deals/add?mautic_id=${
                            customerDetails.mautic_id
                          }`,
                          "_blank"
                        );
                      }}
                    >
                      <div class="icon-box me-0">
                        <svg
                          height={"24"}
                          width={"24"}
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                          <g
                            id="SVGRepo_tracerCarrier"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></g>
                          <g id="SVGRepo_iconCarrier">
                            <circle
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="#006EFA"
                              stroke-width="1.5"
                            ></circle>
                            <path
                              d="M12 17V17.5V18"
                              stroke="#006EFA"
                              stroke-width="1.5"
                              stroke-linecap="round"
                            ></path>
                            <path
                              d="M12 6V6.5V7"
                              stroke="#006EFA"
                              stroke-width="1.5"
                              stroke-linecap="round"
                            ></path>
                            <path
                              d="M15 9.5C15 8.11929 13.6569 7 12 7C10.3431 7 9 8.11929 9 9.5C9 10.8807 10.3431 12 12 12C13.6569 12 15 13.1193 15 14.5C15 15.8807 13.6569 17 12 17C10.3431 17 9 15.8807 9 14.5"
                              stroke="#006EFA"
                              stroke-width="1.5"
                              stroke-linecap="round"
                            ></path>
                          </g>
                        </svg>
                      </div>
                    </button>
                  </Whisper>
                </div>
                <div class="ps-0 pe-0">
                  <Whisper
                    placement="bottom"
                    trigger="hover"
                    speaker={<Tooltip>Create Free Trial</Tooltip>}
                  >
                    <button
                      class="single-box flex-direction-column align-items-center pt-0 pb-0 btn-ghost"
                      onClick={() => {
                        setFormData({
                          ...formData,
                          customerName: customerDetails.name || "",
                          companyName: customerDetails.company_name || "",
                          phoneNumber: customerDetails.phone_number || "",
                          emailId: customerDetails.email || "",
                        });
                        setCreateTrialModalOpen(true);
                      }}
                    >
                      <div class="icon-box me-0">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g id="Edit / Add_Plus_Circle">
                            <path
                              id="Vector"
                              d="M8 12H12M12 12H16M12 12V16M12 12V8M12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21Z"
                              stroke="#006EFA"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </g>
                        </svg>
                      </div>
                    </button>
                  </Whisper>
                </div>
                <div class="ps-0 pe-0">
                  <Whisper
                    placement="bottom"
                    trigger="hover"
                    speaker={<Tooltip>Campaigns</Tooltip>}
                  >
                    <button
                      class="single-box flex-direction-column align-items-center pt-0 pb-0 btn-ghost"
                      onClick={() => setShowManageCampaignsModal(true)}
                    >
                      <div class="icon-box me-0">
                        <svg
                          fill="#006EFA"
                          height="24"
                          width="24"
                          version="1.1"
                          id="Capa_1"
                          xmlns="http://www.w3.org/2000/svg"
                          // xmlns:xlink="http://www.w3.org/1999/xlink"
                          viewBox="0 0 236.108 236.108"
                          // xml:space="preserve"
                        >
                          <g>
                            <path
                              d="M7.5,69.21c-4.142,0-7.5,3.358-7.5,7.5v58.54c0,4.142,3.358,7.5,7.5,7.5s7.5-3.358,7.5-7.5V76.71
                            C15,72.568,11.642,69.21,7.5,69.21z"
                            />
                            <path
                              d="M166.428,25.459h-31.204c-4.142,0-7.5,3.358-7.5,7.5v6.775L27.289,69.517c-3.184,0.944-5.368,3.87-5.368,7.19v58.512
                          c-0.002,0.375,0.034,0.753,0.09,1.132c0.01,0.07,0.02,0.14,0.032,0.209c0.056,0.31,0.124,0.62,0.221,0.928l21.261,67.9
                          c1.004,3.207,3.963,5.261,7.155,5.261c0.741,0,1.495-0.111,2.24-0.344l30.961-9.681c1.899-0.594,3.484-1.918,4.406-3.68
                          c0.923-1.762,1.107-3.819,0.513-5.718l-10.536-33.669l49.459,14.67v6.774c0,4.142,3.358,7.5,7.5,7.5h31.204
                          c4.142,0,7.5-3.358,7.5-7.5V32.959C173.928,28.817,170.57,25.459,166.428,25.459z M72.245,188.546l-16.646,5.205l-14.814-47.311
                          l20.154,5.977L72.245,188.546z M69.078,139.187c-0.021-0.006-0.043-0.013-0.064-0.019l-32.092-9.519V82.306l90.803-26.926v101.202
                          L69.078,139.187z M158.928,171.502h-16.204v-4.873V45.333v-4.873h16.204V171.502z"
                            />
                            <path
                              d="M224.962,147.969l-32.452-16.229c-3.706-1.851-8.21-0.352-10.063,3.354c-1.853,3.705-0.351,8.21,3.354,10.063
                          l32.452,16.229c1.077,0.539,2.221,0.793,3.349,0.793c2.751,0,5.4-1.519,6.714-4.147
                          C230.168,154.327,228.666,149.822,224.962,147.969z"
                            />
                            <path
                              d="M189.161,81.012c1.127,0,2.272-0.255,3.348-0.794l32.453-16.227c3.705-1.853,5.207-6.357,3.354-10.062
                            c-1.852-3.705-6.358-5.207-10.062-3.354l-32.453,16.227c-3.705,1.853-5.207,6.357-3.354,10.062
                            C183.761,79.493,186.41,81.012,189.161,81.012z"
                            />
                            <path
                              d="M228.608,98.48h-27.098c-4.142,0-7.5,3.358-7.5,7.5c0,4.142,3.358,7.5,7.5,7.5h27.098c4.142,0,7.5-3.358,7.5-7.5
                        		C236.108,101.837,232.75,98.48,228.608,98.48z"
                            />
                          </g>
                        </svg>
                      </div>
                    </button>
                  </Whisper>
                </div>
                <div class="ps-0 pe-0">
                  <Whisper
                    placement="bottom"
                    trigger="hover"
                    speaker={<Tooltip>Schedule Meeting</Tooltip>}
                  >
                    <button
                      class="single-box flex-direction-column align-items-center pt-0 pb-0 btn-ghost"
                      onClick={() => setShowScheduleMeetingModal(true)}
                    >
                      <div class="icon-box me-0">
                       <svg
  width="16"
  height="16"
  viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
  fill={
    !customerDetails.email 
      ? "#777"
      : "#006EFA"
  }
>
  <path d="M12.5 1.5H12V0.75C12 0.34 11.66 0 11.25 0C10.84 0 10.5 0.34 10.5 0.75V1.5H5.5V0.75C5.5 0.34 5.16 0 4.75 0C4.34 0 4 0.34 4 0.75V1.5H3.5C2.12 1.5 1 2.62 1 4V13.5C1 14.88 2.12 16 3.5 16H12.5C13.88 16 15 14.88 15 13.5V4C15 2.62 13.88 1.5 12.5 1.5ZM13.5 13.5C13.5 14.05 13.05 14.5 12.5 14.5H3.5C2.95 14.5 2.5 14.05 2.5 13.5V6H13.5V13.5ZM2.5 4C2.5 3.45 2.95 3 3.5 3H4V3.75C4 4.16 4.34 4.5 4.75 4.5C5.16 4.5 5.5 4.16 5.5 3.75V3H10.5V3.75C10.5 4.16 10.84 4.5 11.25 4.5C11.66 4.5 12 4.16 12 3.75V3H12.5C13.05 3 13.5 3.45 13.5 4V4.5H2.5V4Z"/>
</svg>
                      </div>
                    </button>
                  </Whisper>
                </div>
                <div class="ps-0 pe-0">
                  <Whisper
                    placement="bottom"
                    trigger="hover"
                    speaker={<Tooltip>Login To Account</Tooltip>}
                  >
                    <button
                      class="single-box flex-direction-column align-items-center pt-0 pb-0 btn-ghost"
                      onClick={handleShowLoginToAccountModal}
                      disabled={
                        !customerDetails.product ||
                        customerDetails.product.length === 0
                      }
                    >
                      <div class="icon-box me-0">
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill={
                            !customerDetails.product ||
                            customerDetails.product.length === 0
                              ? "#777"
                              : "#006EFA"
                          }
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_2014_3381)">
                            <path d="M6.83337 7.87756H0.5C0.223999 7.87756 0 7.65356 0 7.37756C0 7.10156 0.223999 6.87756 0.5 6.87756H6.83337C7.10938 6.87756 7.33337 7.10156 7.33337 7.37756C7.33337 7.65356 7.10938 7.87756 6.83337 7.87756Z"></path>
                            <path d="M4.33337 10.3776C4.20532 10.3776 4.07739 10.3289 3.97998 10.231C3.78467 10.0355 3.78467 9.71887 3.97998 9.52356L6.12671 7.37695L3.97998 5.23096C3.78467 5.03552 3.78467 4.71887 3.97998 4.52356C4.17529 4.32825 4.49194 4.32825 4.68738 4.52356L7.18738 7.02356C7.38269 7.21887 7.38269 7.53552 7.18738 7.73096L4.68738 10.231C4.58936 10.3289 4.4613 10.3776 4.33337 10.3776Z"></path>
                            <path d="M10.6667 16C9.9314 16 9.3335 15.4064 9.3335 14.6765V2.76595C9.3335 2.20025 9.69617 1.69537 10.2361 1.50939L14.2415 0.184016C15.1375 -0.088596 16.0001 0.571124 16.0001 1.44263V13.3532C16.0001 13.9183 15.6375 14.4225 15.0981 14.609L11.0914 15.9352C10.9454 15.9801 10.8102 16 10.6667 16ZM14.6667 1.11174C14.6234 1.11174 14.5868 1.11707 14.5475 1.12895L10.5588 2.44899C10.4281 2.49407 10.3335 2.62504 10.3335 2.76595V14.6765C10.3335 14.9023 10.5801 15.0544 10.7861 14.9902L14.7748 13.6702C14.9048 13.6251 15.0001 13.4941 15.0001 13.3532V1.44263C15.0001 1.26065 14.8508 1.11174 14.6667 1.11174Z"></path>
                            <path d="M14.6667 1.11174C14.6234 1.11174 14.5868 1.11707 14.5475 1.12895L10.5588 2.44899C10.4281 2.49407 10.3335 2.62504 10.3335 2.76595V14.6765C10.3335 14.9023 10.5801 15.0544 10.7861 14.9902L14.7748 13.6702C14.9048 13.6251 15.0001 13.4941 15.0001 13.3532V1.44263C15.0001 1.26065 14.8508 1.11174 14.6667 1.11174Z"></path>
                            <path
                              d="M5.84668 3.54718C5.57068 3.54718 5.34668 3.32318 5.34668 3.04718V2.04718C5.34668 1.03583 6.16858 0.213806 7.17993 0.213806H14.6799C14.9559 0.213806 15.1799 0.437805 15.1799 0.713806C15.1799 0.989807 14.9559 1.21381 14.6799 1.21381H7.17993C6.72058 1.21381 6.34668 1.58783 6.34668 2.04718V3.04718C6.34668 3.32318 6.12268 3.54718 5.84668 3.54718Z"
                              // stroke="#006EFA"
                              stroke-width="0.3"
                            ></path>
                            <path
                              d="M9.83301 14.5409H7.16626C6.15491 14.5409 5.33301 13.7189 5.33301 12.7076V11.7076C5.33301 11.4315 5.55701 11.2076 5.83301 11.2076C6.10901 11.2076 6.33301 11.4315 6.33301 11.7076V12.7076C6.33301 13.1669 6.70691 13.5409 7.16626 13.5409H9.83301C10.109 13.5409 10.333 13.7649 10.333 14.0409C10.333 14.3169 10.109 14.5409 9.83301 14.5409Z"
                              // stroke="#006EFA"
                              stroke-width="0.3"
                            ></path>
                          </g>
                          <defs>
                            <clipPath id="clip0_2014_3381">
                              <rect width="16" height="16" fill="white"></rect>
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                    </button>
                  </Whisper>
                </div>
              </div>
            </div>
          </div>
          {/* {customerDetails.last_activity_date && (
          <div className="last-activity">
            <svg
              width="6px"
              height="6px"
              viewBox="0 0 24.00 24.00"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              stroke="#28A745"
              stroke-width="0.00024000000000000003"
            >
              <g id="SVGRepo_bgCarrier" stroke-width="0">
                <rect
                  x="0"
                  y="0"
                  width="24.00"
                  height="24.00"
                  rx="12"
                  fill="#28A745"
                  strokewidth="0"
                ></rect>
              </g>
              <g
                id="SVGRepo_tracerCarrier"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke="#28A745"
                stroke-width="0.624"
              ></g>
              <g id="SVGRepo_iconCarrier">
                <path
                  d="M12 9.5C13.3807 9.5 14.5 10.6193 14.5 12C14.5 13.3807 13.3807 14.5 12 14.5C10.6193 14.5 9.5 13.3807 9.5 12C9.5 10.6193 10.6193 9.5 12 9.5Z"
                  fill="#28A745"
                ></path>
              </g>
            </svg>
            Last Activity Date:{" "}
            {getFormattedDate(
              customerDetails.last_activity_date,
              "MMM, dd yyyy 'at' hh:mm a"
            )}
          </div>
          )} */}
        </div>
      </div>
      <CreateFreeTrialParent
        show={createTrialModalOpen}
        mailTriggerPopup={mailTriggerPopup}
        formData={formData}
        setFormData={setFormData}
        apiUrl={apiUrl}
        setApiUrl={setApiUrl}
        productOptions={getAvailableProductsForFreeTrial()}
        setModalOpen={setCreateTrialModalOpen}
        fixedCustomerDetails={true}
        mautic_id={customerDetails.mautic_id}
      />
      <LoginToAccount
        show={showLoginToAccountModal}
        data={loginData}
        close={handleCloseLoginToAccountModal}
      />
      <ManageCampaignsModal
        showModal={showManageCampaignsModal}
        closeModal={() => setShowManageCampaignsModal(false)}
        contactId={customerDetails.mautic_id}
      />
      <SendEmailToLeadModal
        showModal={showSendEmailToLeadModal}
        closeModal={() => setShowSendEmailToLeadModal(false)}
        contactId={customerDetails.mautic_id}
        currentUser={currentUser || {}}
      />
      <ScheduleMeetingModal
        showModal={showScheduleMeetingModal}
        closeModal={() => setShowScheduleMeetingModal(false)}
        customerDetails={customerDetails}
      />
      <FreeTrialConfirmation
        formData={formData}
        show={emailModalOpen}
        close={setEmailModalOpen}
        handleOkClick={() => setEmailModalOpen(false)}
      />
    </div>
  );
};

export default CrmLeadsHeader;



// WEBPACK FOOTER //
// ./src/components/crm/leads/components/CrmLeadsHeader.js